import { useQuery, useQueryClient } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { LeadDetailsResponse } from '../types';
import { LEAD_DETAILS, UNREAD_SMS_COUNT, UNREAD_SMS_LIST } from './constants';

const useGetLeadDetails = (lead_id: string) => {
    const req = useRequest();
    const queryClient = useQueryClient();

    // Backend flips `read_at` on inbound SMS as a side-effect of this fetch.
    // Refresh the global unread badge + popover so they reflect the new state.
    const request = React.useCallback(async () => {
        const response = await req<LeadDetailsResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/lead/`,
            query: { lead_id }
        });
        queryClient.invalidateQueries({ queryKey: [UNREAD_SMS_COUNT] });
        queryClient.invalidateQueries({ queryKey: [UNREAD_SMS_LIST] });
        return response;
    }, [lead_id, req, queryClient]);

    return useQuery({
        queryFn: request,
        queryKey: [LEAD_DETAILS, lead_id]
    });
};

export default useGetLeadDetails;
